import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import queryString from 'query-string'
import { Link, Redirect } from 'react-router-dom'
import { tagHotjarRecording } from '../../helpers/util'
import useUsers from '../../hooks/useUsers'
import useAuth from '../../hooks/useAuth'
import AppRoutes from '../../routes/appRoutes'
import LoginTransition from '../LoginPage/components/LoginTransition'
import NewLiftOneNowLogo from '../../svg/NewLiftOneNowLogo.svg'
import ResetPasswordForm from './components/ResetPasswordForm'
import useGlobalLoading from '../../hooks/useGlobalLoading'

const ResetPasswordPage = props => {
    const { match, location } = props

    const [formError, setFormError] = useState('')
    const [email, setEmail] = useState('')

    const { handleResetPassword } = useUsers()
    const { handleLoginSuccess } = useAuth()
    const { changeLoading } = useGlobalLoading()

    useEffect(() => {
        let params = location.search
            ? queryString.parse(location.search)
            : { email: '' }
        setEmail(params?.email)
    }, [])

    const onResetedPassword = response => {
        //put into local storage
        changeLoading(false)
        if (response.status === 200) {
            var session = JSON.stringify(response.data.session)
            localStorage.setItem('session', session)
            handleLoginSuccess(response?.data?.session)
        }
    }

    const onResetPasswordError = error => {
        changeLoading(false)
        tagHotjarRecording('API Error')
        const { errors } = error.response.data
        const errorMessage = error.response.data.message

        if (errors && Array.isArray(errors.password)) {
            setFormError(errors?.password[0])
        } else {
            setFormError(errorMessage)
        }
    }

    const resetPassword = data => {
        changeLoading(true)
        handleResetPassword(data, onResetedPassword, onResetPasswordError)
    }

    const onSubmit = values => {
        resetPassword({
            email,
            token: props?.match?.params?.token,
            ...values,
        })
    }

    return undefined === match?.params?.token ? (
        <Redirect to={AppRoutes.forgotPassword()} />
    ) : (
        <LoginTransition>
            <div className="transition-all w-full flex flex-col items-center justify-start sm:p-16 p-6 sm:gap-y-6 gap-y-4">
                <section className="flex flex-col items-center justify-start w-full">
                    <img src={NewLiftOneNowLogo} />
                    <h1 className="sm:text-3xl text-2.5xl mt-4 font-bold text-white">
                        Reset Password
                    </h1>
                </section>
                {/* <LoginForm redirect={redirect} /> */}
                <ResetPasswordForm
                    error={formError}
                    onSubmit={onSubmit}
                    email={email}
                />
                <span className="font-medium text-sm text-white">
                    <Link
                        to={AppRoutes.login()}
                        className="text-yellow underline"
                    >
                        Return to Sign In
                    </Link>
                </span>
            </div>
        </LoginTransition>
    )
}

ResetPasswordPage.propTypes = {
    location: PropTypes.shape({
        search: PropTypes.string,
    }),
    match: PropTypes.shape({
        params: PropTypes.shape({
            token: PropTypes.string,
        }),
    }),
}

export default ResetPasswordPage
